<script setup>
import { defineProps, ref, onMounted, defineEmits } from "vue";
import bootstrap from "bootstrap/dist/js/bootstrap";
import DataService from "../../services/data.service";
import EventBus from "../../common/EventBus";
import Swal from "sweetalert2";
import { Form, Field, ErrorMessage } from "vee-validate";
import { schemaRequest } from "../schemas/validationSchema";
const emit = defineEmits(["request-created"]);
const props = defineProps({
  initialData: {},
});

const institutions = ref([]);
const reasons = ref([]);
const currentDate = ref("");
const solicitud = ref({});

solicitud.value =
  props.initialData && Object.keys(props.initialData).length
    ? {
        ubicacion: props.initialData.ubicacion || "000000000",
        institucion_id: props.initialData.institucion_id || null,
        motivo: props.initialData.motivo || null,
        fecha_solicitada: props.initialData.fecha_solicitada || "",
        tipo_licencia: props.initialData.tipo_licencia || 1,
        archivo: props.initialData.archivo || null,
      }
    : {
        ubicacion: "000000000",
        institucion_id: "",
        motivo: null,
        fecha_solicitada: currentDate,
        tipo_licencia: 1,
        archivo: null,
      };

onMounted(() => {
  const storedInstitutions = localStorage.getItem("instituciones");
  if (storedInstitutions) {
    const parsedInstitutions = JSON.parse(storedInstitutions);
    institutions.value = storedInstitutions
    institutions.value = parsedInstitutions.filter(
      (institution) => institution.parent === null
    );
  }

  DataService.getMotivos().then(
    (response) => {
      reasons.value = response.data;
    },
    (error) => {
      const content =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      if (error.response && error.response.status === 403) {
        EventBus.dispatch("logout");
      }

      return content;
    }
  );
  getDay();
});

// Función para manejar la selección de archivo
const onFileChange = (event) => {
  const file = event.target.files[0];
  if (file) {
    const reader = new FileReader();
    reader.onloadend = () => {
      // Solo almacena el contenido base64 sin la parte de metadatos
      solicitud.value.archivo = reader.result.split(",")[1];
      const fileType = file.type.split("/")[1];
      solicitud.value.tipo = fileType;
    };
    reader.readAsDataURL(file);
  }
};
const getDay = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");

  currentDate.value = `${year}-${month}-${day}`;
};

const saveChanges = () => {
  const modal = bootstrap.Modal.getInstance("#ModalCreateRequest");

  DataService.postRequestCreate(JSON.stringify(solicitud.value)).then(
    (response) => {
      if (response.data.status == false) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response.data.message,
        });
      } else {
        Swal.fire({
          icon: "success",
          title: "Nueva Solicitud creada",
        });
        emit("request-created");
      }
      if (modal) {
        modal.hide();
      }
    },
    (error) => {
      // Manejo de errores
      console.error("Error al guardar la solicitud:", error);
      if (modal) {
        modal.hide();
      }
    }
  );

  if (!modal) {
    console.error("No se pudo obtener la instancia del modal");
  }
};
</script>

<template>
  <div
    class="modal fade"
    id="ModalCreateRequest"
    tabindex="-1"
    aria-labelledby="ModalCreateRequest"
    aria-hidden="true"
    ref="ModalCreateRequest"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header" style="display: block">
          <div class="row mb-1">
            <div class="col-6">
              <h5 class="modal-title" id="fichaModalLabel">
                Datos de solicitud
              </h5>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <Form
            ref="formRequest"
            :validation-schema="schemaRequest"
            @submit="saveChanges"
          >
            <div class="col-12 col-md">
              <label for="institucion" class="form-label">Institución:</label>
              <Field
                placeholder="Institución"
                as="select"
                class="form-select"
                id="institucion_id"
                v-model="solicitud.institucion_id"
                name="institucion_id"
                label="institucion_id"
              >
                <option
                  v-for="institution in institutions"
                  :key="institution.id"
                  :value="institution.id"
                >
                  {{ institution.nombre }}
                </option>
              </Field>
              <ErrorMessage name="institucion_id" />
            </div>

            <div class="row mb-2">
              <div class="col-12 col-md">
                <label for="motivo" class="form-label">Motivo:</label>
                <Field
                  label="motivo"
                  as="select"
                  class="form-select"
                  id="motivo"
                  name="motivo"
                  v-model="solicitud.motivo"
                >
                  <option
                    v-for="reason in reasons"
                    :key="reason.id"
                    :value="reason.id"
                  >
                    {{ reason.nombre }}
                  </option>
                </Field>
                <ErrorMessage name="motivo" />
              </div>
            </div>

            <div class="col-12 col-md mb-3">
              <label for="currentDate" class="form-label"
                >Fecha de Licencia:</label
              >
              <input
                type="date"
                id="currentDate"
                class="form-control"
                v-model="solicitud.fecha_solicitada"
                readonly
              />
            </div>

            <div class="row mb-2">
              <div class="col-12">
                <label for="file" class="form-label">Cargar Imagen:</label>
                <input
                  type="file"
                  class="form-control"
                  id="file"
                  @change="onFileChange"
                  accept="image/*"
                />
              </div>
            </div>

            <input type="hidden" v-model="solicitud.tipo_licencia" />

            <div class="row mt-5 mb-2 justify-content-md-end">
              <hr>
              <div class="col-12 col-md-4">
                <button
                  type="button"
                  class="btn btn-secondary btn-sm w-100"
                  data-bs-dismiss="modal"
                >
                  Cerrar
                </button>
              </div>
              <div class="col-12 col-md-4">
                <button type="submit" class="btn btn-primary btn-sm w-100">
                  Guardar Cambios
                </button>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>
